import axios from "axios";
import { v4 as uuidv4 } from 'uuid';

export const HandleImageGenerate = async ({
    AIPrompt,
    selectedGenerativeModel,
    selectedStyle,
    setAiLoading,
    setErrorMessage,
    setOpenSnackbar,
    setSeverity,
}) => {
    let endpoint;

    switch (selectedGenerativeModel?.model) {
        case "vyro":
            endpoint = "https://api.vyro.ai/v2/image/generations";
            break;
        default:
            setErrorMessage("Unsupported AI model");
            setOpenSnackbar(true);
            setSeverity("error");
            return null;
    }

    try {
        setAiLoading(true);

        // Create FormData for the request
        const requestBody = new FormData();
        requestBody.append("prompt", AIPrompt);
        requestBody.append("style", selectedStyle);
        requestBody.append("aspect_ratio", "1:1");
        requestBody.append("seed", "2");

        // Make API request
        const response = await axios.post(endpoint, requestBody, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${selectedGenerativeModel?.apiKey}`,
            },
            responseType: "blob",
        });


        const uniqueCode = uuidv4();
        const imageNameWithUniqueCode = `generatedImage-${uniqueCode}.png`;

        // Convert Blob to File
        const imageBlob = response.data;
        const file = new File([imageBlob], imageNameWithUniqueCode, { type: imageBlob.type });

        // Generate a preview URL
        const previewURL = URL.createObjectURL(imageBlob);

        return { previewURL, file };

    } catch (error) {
        console.error("Error:", error.response?.data || error.message);
        setErrorMessage("Error generating");
        setOpenSnackbar(true);
        setSeverity("error");
        return null;
    } finally {
        setAiLoading(false);
    }
};
